import { Injectable } from '@angular/core';
import { ApiService } from '@services/api/api.service';
import { Crypto } from '@services/helpers/encryption-utils';

@Injectable({
  providedIn: 'root',
})
export class ProjectService {
  constructor(private api: ApiService) {}

  isAccess(project: any, userTeams: any[]): boolean {
    let haveAssociation = false;
    let accounts = [...userTeams]; // Clone user teams
    let projectAssociationSettings: string[] = [];

    // Get current user ID
    const currentUser: string = this.api.getUserId();

    // Get current user's company from localStorage
    const currentUserCompany = Crypto.decrypt(localStorage.getItem('company')) || [];

    // Add current user ID to accounts
    accounts.push(currentUser);

    // Add company IDs to accounts if available
    if (Array.isArray(currentUserCompany)) {
      currentUserCompany.forEach(company => accounts.push(company?._id));
    }

    // Extract relevant association settings from project if available
    if (project?.projectassociation_settings?.length > 0) {
      const settings = project.projectassociation_settings[0];

      // Collect all associated users and companies
      projectAssociationSettings = [
        ...(settings?.externals_contacts || []),
        ...(settings?.externals_company || []),
        ...(settings?.salesmanagers_users || []),
        ...(settings?.admins_users || []),
        ...(settings?.internals_users || []),
      ];

      // Add only teams that exist in userTeams
      [...(settings?.salesmanagers_teams || []), ...(settings?.admins_teams || []), ...(settings?.internals_teams || [])].forEach(teamId => {
        if (userTeams.includes(teamId)) {
          projectAssociationSettings.push(teamId);
        }
      });
    }

    // Check if any account exists in the project association settings
    haveAssociation = accounts.some(account => projectAssociationSettings.includes(account?.toString()));

    // Get user role from localStorage
    const role = Crypto.decrypt(localStorage.getItem('role'))?.toLowerCase();

    // Grant access if the user is associated or has a privileged role
    return haveAssociation || ['master admin', 'operations manager'].includes(role);
  }

  devProjects(record: any[] = [], UserData: any): any[] {
    const { tags = [] } = UserData || {};

    const isTagDeveloper = tags.some(tag => tag?.tag_name?.toLowerCase()?.startsWith('developer'));

    const role = Crypto.decrypt(localStorage.getItem('role'))?.toLowerCase();
    const contactType = Crypto.decrypt(localStorage.getItem('contact_type'))?.toLowerCase() || '';

    let companiesList: any[] = [];

    const decryptedCompanies = Crypto.decrypt(localStorage.getItem('company'));
    if (Array.isArray(decryptedCompanies)) {
      companiesList = decryptedCompanies;
    }

    const hasDeveloperAssociation =
      companiesList?.some(
        company =>
          company?.related_tags?.toString()?.includes('developer') ||
          company?.tags?.toString()?.includes('developer') ||
          company?.company_type?.toLowerCase()?.startsWith('developer')
      ) ||
      contactType?.startsWith('developer') ||
      isTagDeveloper;

    if (record.length > 0 && role === 'contacts' && hasDeveloperAssociation) {
      return record.map(project => {
        const settings = project?.projectassociation_settings?.[0];

        if (settings) {
          const isDeveloperUser = settings?.externals_contacts?.some(
            userId => userId === this.api.getUserId() && ['developer', 'developers']?.includes(contactType)
          );

          const isDeveloperCompany = settings?.externals_company?.some(companyId =>
            companiesList.some(
              localCompany =>
                localCompany?._id === companyId &&
                (localCompany?.company_type?.toLowerCase()?.includes('developer') ||
                  localCompany?.related_tags?.toString()?.toLowerCase()?.includes('developer') ||
                  localCompany?.tags?.toString()?.toLowerCase()?.includes('developer'))
            )
          );

          if (isDeveloperUser || isDeveloperCompany) {
            return { ...project, is_visible_to_user: true, isdeveloper: true };
          }
        }

        return { ...project, is_visible_to_user: false, isdeveloper: false };
      });
    }
    return record;
  }

  checkUserOpenProject(id) {
    let payload = {
      office_id: this.api.getOfficeId(),
      user_id: this.api.getUserId(),
      project_id: id,
      login_date_time: new Date(),
    };
    this.api.post('/project/activity-user', payload).subscribe(() => {});
  }
}
